<title>{{ introductionSandboxToolPage.htmlTitle }}</title>
<div class="container mt-5">
  <iframe
    class="GS-sandbox"
    width="560"
    height="315"
    src="//videos.ctfassets.net/nwnmkeyu03hy/2lvQzihemTNgvFxpA4WkMV/60b453b27cea362c53f77d6dba171472/ndcSandBox-ASxx.mp4"
    frameborder="0"
    allowfullscreen
  ></iframe>
</div>
